import { AppThunkAction } from '../index';
import agent from 'api/agent';
import globalStore from '../globalStore';
import { FinanceAction } from './actions';
import { parseFileNameFromContentDisposition } from 'helpers/helperFunctions';
import I18n from 'i18n-js';

export const actionCreators = {
    // TODO: remove finance item related
    // selectFinanceItem:
    //     (payload: any): AppThunkAction<FinanceAction> =>
    //     (dispatch) => {
    //         dispatch({
    //             type: 'SELECT_FINANCE_ITEM',
    //             payload,
    //         });
    //     },
    getFinance:
        (dateFrom: any, dateTo: any, restaurantId: string = ''): AppThunkAction<FinanceAction> =>
        (dispatch) => {
            dispatch({
                type: 'GET_FINANCE_DETAILS_START',
            });
            globalStore.actionCreators.showSpiner()(dispatch);
            agent.Restaurants.GetFinance(dateFrom, dateTo, restaurantId)
                .then((res) => {
                    dispatch({
                        type: 'GET_FINANCE_DETAILS_SUCCESS',
                        // categories: res.categories,
                        categories: [],
                        orders: res.orders,
                        payload: res,
                    });
                })
                .catch((e) => {
                    dispatch({
                        type: 'GET_FINANCE_DETAILS_ERROR',
                    });
                    globalStore.actionCreators.showToaster('error', e)(dispatch);
                })
                .finally(() => globalStore.actionCreators.hideSpiner()(dispatch));
        },
    getFinanceExcel:
        (dateFrom: string, dateTo: string, restaurantId?: string): AppThunkAction<FinanceAction> =>
        (dispatch) => {
            globalStore.actionCreators.showSpiner()(dispatch);
            agent.Restaurants.GetFinanceExcel(dateFrom, dateTo, restaurantId)
                .then((res) => {
                    const blob = res.data;
                    const filename = parseFileNameFromContentDisposition(
                        res.headers['content-disposition'],
                        'finance',
                        'xlsx'
                    );
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    a.remove();
                    URL.revokeObjectURL(url);
                })
                .catch((e) => {
                    globalStore.actionCreators.showToaster('error', e)(dispatch);
                })
                .finally(() => globalStore.actionCreators.hideSpiner()(dispatch));
        },
    getPaymentReport:
        (from: Date, to: Date, restaurantId: string = ''): AppThunkAction<FinanceAction> =>
        (dispatch) => {
            globalStore.actionCreators.showSpiner()(dispatch);
            agent.Restaurants.GetPaymentsReport(from, to, restaurantId)
                .then((res) => {
                    dispatch({
                        type: 'GET_PAYMENT_REPORT_SUCCESS',
                        payload: res,
                    });
                })
                .catch((e) => {
                    globalStore.actionCreators.showToaster('error', I18n.t('common.somethingWrong'))(dispatch);
                })
                .finally(() => globalStore.actionCreators.hideSpiner()(dispatch));
        },
};
